import type { Collection as CollectionDto } from './dto';
import type { Collection as CollectionModel } from './model';

export function mapCollectionDtoToModel(dto: CollectionDto): CollectionModel {
  return {
    id: String(dto.id),
    highlightsCount: dto.highlight_count,
    name: dto.name,
    userId: dto.user_id,
    userName: dto.user_name,
    created: dto.created,
    keyName: dto.key_name,
  };
}
